/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import ThreeDotsLoader from '../../../Components/LoadingDots';
import CategoryManager from '../CategoryManager';
import CustomFilter from '../CustomFilters';
import { DistributorActions } from '../../../redux/actions';
import { distributorService } from '../../../service/distributor.service';
import { FilterPayloadConstruction } from '../../../redux/helper/FIlterPayloadConstructor';

function ProductsModal({
    Products, setModalType, DistributorData, setDistributorData, HandleUpdate, loading, setloading, FilterData,
}) {
    const [result, setresult] = useState([]);
    const [Segments, setSegments] = useState([]);

    const findSegmnet = (obj, searchKey, arr) => {
        for (const property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (Object.keys(obj[property]).length > 0 && property !== '' && property !== 'concatenated_segment') {
                    if (obj[property].concatenated_segment.split('.').includes(searchKey)) {
                        if (!arr.includes(obj[property].concatenated_segment)) {
                            arr.push(obj[property].concatenated_segment);
                        }
                    }
                    findSegmnet(obj[property], searchKey, arr);
                } else if (obj.concatenated_segment.split('.').includes(searchKey)) {
                    if (!arr.includes(obj[property].concatenated_segment)) {
                        arr.push(obj[property].concatenated_segment);
                    }
                }
            }
        }
        return arr;
    };

    const handleCheckBox = (item, segments) => {
        let copy = [];
        if (segments) {
            copy = [...Segments];
        } else {
            copy = [...checkBox];
        }
        let keyval = item;
        if (copy.includes(item)) {
            keyval = item.split('.')[item.split('.').length - 1];
            const parentKeyValue = item.split('.')[item.split('.').length - 2];
            let idx;
            const Duplicates = [];
            copy.map((val, i) => {
                if (val?.split('.').includes(keyval)) {
                    Duplicates.push(copy.indexOf(val));
                }
            });
            if (Duplicates.length > 1) {
                idx = Duplicates[Duplicates.length - 1];
            } else {
                idx = copy.indexOf(item);
            }
            copy.splice(idx, 1);
            const removeArr = [];
            copy.map((val) => {
                if (!val?.split('.').includes(keyval)) {
                    removeArr.push(val);
                }
            });
            let parentCount = 0;
            copy.map((val) => {
                if (val?.split('.').includes(parentKeyValue)) {
                    parentCount += 1;
                }
            });
            copy = removeArr;
        } else {
            if (item.split('.').length === 0) {
                copy.push(item);
            } else {
                let temp = '';
                item.split('.').map((val, i) => {
                    temp += i === 0 ? `${val}` : `.${val}`;
                    if (!copy.includes(temp)) {
                        copy.push(temp);
                    }
                });
                keyval = item.split('.')[item.split('.').length - 1];
            }
            if (segments === undefined) {
                findSegmnet(Filters, keyval, copy);
            }
        }
        if (segments) {
            setSegments(copy);
        } else {
            setcheckBox(copy);
        }
    };

    function transform(object, newid, id1) {
        if (Object.keys(object).length > 0) {
            return Object
                .entries(object).filter(([keyVal, value]) => value !== '' && keyVal !== '')
                .map(([name, value]) => {
                    if (value.hasOwnProperty('')) {
                        Object.keys(value).map((key) => key === '' && delete value[key]);
                    }
                    if (value !== '') {
                        const con = {
                            name,
                            ...(value && typeof value === 'object' && !value.hasOwnProperty('')
                                ? {
                                    newid: `${id1++}-${name}`,
                                    id: `${newid === '' ? '' : `${newid}.`}${name}`,
                                    items: transform(value, `${newid === '' ? '' : `${newid}.`}${name}`, Object.keys(object).length),
                                }
                                : { newid: `${id1++}-${name}`, id: `${newid === '' ? '' : `${newid}.`}${name}` }),
                        };
                        DistributorData.PRODUCT_CATEGORIES.forEach((element) => {
                            if ((con.id.startsWith(element) || element.includes(con.id)) && !con.hasOwnProperty('status')) {
                                con.status = 1;
                            }
                        });
                        return con;
                    }
                });
        }
    }

    const handleFetchFilters = useCallback((() => {
        distributorService.GetAllProductsFiters().then((res) => {
            if (res.data.success_status) {
                const data = transform(res.data.data, '', 1);
                setresult(data);
            }
        });
    }), []);

    useEffect(() => {
        handleFetchFilters();
    }, []);

    useEffect(() => {
        if (Object.keys(FilterData).length > 0) {
            setSegments(FilterData.filters);
        }
    }, [FilterData]);

    return (
        <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none min-w-[441px] min-h-[500px]">
            <div
                className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
            >
                <div className="modal-header flex flex-shrink-0 items-center justify-center py-5 rounded-t-md relative">
                    <h5 className="text-lg font-semibold text-[#090406]" id="exampleModalScrollableLabel">
                        Manage Product category(s)
                    </h5>
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" className="absolute top-[18px] right-[18px]">
                        <img
                            src="/images/Component1587.svg"
                            alt="icon"
                            className="w-3 h-3"
                            onClick={() => setModalType('')}
                        />
                    </button>
                </div>
                <div className="modal-body relative pb-5 px-10 flex justify-center flex-col">
                    <div className="h-[250px] overflow-auto mt-[26px] sidebar cursor-pointer">
                        {result?.length > 0 && (
                            <CustomFilter
                                result={result}
                                Segments={Segments}
                                handleCheckBox={handleCheckBox}
                            />
                        )}
                    </div>

                    <div className="pt-6 flex justify-center">
                        <button onClick={() => HandleUpdate(FilterPayloadConstruction(result), 'PRODUCT_CATEGORIES')} type="button" className="w-[168px] h-[42px] border border-[#707070] bg-[#555259] rounded-lg text-xs6 font-semibold text-[#FFFFFF] flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close">
                            {loading ? <ThreeDotsLoader /> : 'Save Changes'}
                        </button>
                    </div>
                </div>
                {' '}

            </div>
        </div>

    );
}
const mapStateToProps = (state) => {
    const { Products, FilterData } = state;
    return { Products, FilterData };
};
const mapDispatchToProps = {
    // GetProductList: DistributorActions.ProductListing,
    // handleSegments: DistributorActions.handleFiltersData,
    // GetCartItems: DistributorActions.GetCartItems,
    handleFiltersData: DistributorActions.handleFiltersData,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductsModal);

// export default ProductsModal;
